/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @nx/enforce-module-boundaries */
import { Button, Input, InputGroup, InputLeftElement, InputRightElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import {
  EventIcon,
  HomeIcon,
  JobsIcon,
  TeamIcon,
  TeamNewIcon,
} from '@mybridge/icons';
import { useDisclosure } from '@mybridge/ui/hooks';
import { IconButton } from '@mybridge/ui/icon-button';
import { Box, Circle, HStack } from '@mybridge/ui/layout';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConversationList from 'v4/components/header/conversation-list';
import { getUserFullName, getUserProfilePic } from 'v4/lib/commons';
import { UserOnboardingModal } from 'v4/snippets/onboarding/onboarding-modal';
import {
  setLoggedIn,
  setOpenAuthModal,
  setChatLoggedIn,
  setPageLoaded,
  logout,
  googleSignIn,
} from 'v4/store/actions/auth.actions';
import { getOnboardingStatus } from 'v4/store/actions/onboarding.actions';
import { getUserProfileInfo, updateUserDetails, userProfileAddInfo } from 'v4/store/actions/user-profile.actions';
import { ActivateAccountModal } from '../activate-account-modal';
import { ChangeEmailModal } from '../change-email-modal';
import { ConfirmResetPasswordModal } from '../confirm-reset-password-modal';
import { RequestResetPasswordModal } from '../request-reset-password-modal';
import { SendVerifyLinkModal } from '../send-verify-link-modal';
import { SigninModal } from '../sign-in-modal';
import { SignupModal } from '../sign-up-modal';
import { VerifyOtpModal } from '../verify-otp-modal';
import { ForgotPasswordResetModal } from '../forgot-password-reset-modal';
import { ProfileMenu } from './profile-menu';
import NotificationDropdown from './notifications';
import { getAllConnectionsData } from 'v4/store/actions/connection.actions';
import { getAllCompanyPages } from 'v4/store/actions/companyPages.actions';
import MeetingDropdown from 'v4/components/header/meeting-dropdown';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
import {
  setFcmToken,
  getNotificationList,
} from 'v4/store/actions/notification.actions';
import { getMessaging, onMessage } from 'firebase/messaging';
import { getFirebaseApp } from 'v4/utils/firebase';
import useFcmToken from 'v4/lib/useFcmToken';
import {
  generateMeetingId,
  setMeetNow,
  setMeetingWindowed,
} from 'v4/store/actions/meeting.actions';
import MyBridgeAvatar from 'v4/components/common/MyBridgeAvatar';
// import { PageRoutes } from 'v4/lib/routes';
import { PageRoutes, isPublicPath } from 'v4/lib/routes';
import { isTokenValid } from 'v4/lib/auth';
import {
  getNotificationCounts,
  setMobileDevice,
  setTabletDevice,
} from 'v4/store/actions/global.data.actions';
import { isBrowser, isMobile, isTablet } from 'react-device-detect';
import { SearchIcon } from '@mybridge/icons/Search';
import { Badge, Tooltip, useMediaQuery } from '@mybridge/ui';
import { AddIcon, CopyIcon } from '@chakra-ui/icons';
import { openCreatePostModal } from 'v4/store/actions/post.actions';
import { signOut, useSession } from 'next-auth/react';
import StatusProfileDropdown from 'v4/components/header/status-dropdown/StatusProfileDropdown';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { loadDictionary, setLanguage } from 'v4/store/slices/translationSlice';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { Spinner } from '@chakra-ui/react';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
import { useBranchLink } from 'v4/components/branch-sdk/branch-create';
import { useChatSocket } from 'packages/mybridgev4/hooks/useChatSocket';
import { useQuery } from '@tanstack/react-query';
export const AuthHeader = (props) => {
  const { loggedIn, openAuthModal, access, pending } = useSelector((state) => state.user);
  const { currentMeetingState } = useSelector((state) => state.meeting);
  const { teamChatNotications } = useSelector((state) => state.chatReducer);
  const {globalNotificationData} = useSelector((state) => state.globalData);
  const [unreadCount, setUnreadCount] = useState(0);
  const { onEvent } = useChatSocket();

  const { teamCommunityList, teamsListing } = useSelector((state) => state.teamsCommunity);
  const { userProfileInfo, loading } = useSelector(
    (state) => state.userProfile
  );
    const [isTeamsLoading, setIsTeamsLoading] = useState(false);

  const openAuthModalDisc = useDisclosure();
  const notifDisc = useDisclosure();
  const onboardingDisc = useDisclosure();
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const [maxTabletDimension767] = useMediaQuery('(max-width: 767px)');
  const [maxTabletDimension992] = useMediaQuery('(max-width: 992px)');
  const maxTabletDimension = loggedIn ? maxTabletDimension767 : maxTabletDimension992;
  const isMobileOrTablet = isMobile || isTablet || maxTabletDimension;

  useQuery({
    queryKey: ['company-pages', userProfileInfo?.id],
    queryFn: () => dispatch(getAllCompanyPages()).then((res) => res.payload),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: loggedIn && !!userProfileInfo?.id,
  });
  
  useQuery({
    queryKey: ['connections', userProfileInfo?.id],
    queryFn: () => dispatch(getAllConnectionsData()).then((res) => res.payload),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: loggedIn && !!userProfileInfo?.id,
  });
  
  const direction = useDirection();
  const {
    push,
    pathname,
    asPath,
    isReady,
    query: { pg },
  } = useRouter();
  const { is_onboarding_completed, is_active = true } = userProfileInfo ?? {};
  const { onboardingStatus } = useSelector((state) => state.onboarding) ?? {};
  const { fcmToken, notificationPermissionStatus } = useFcmToken();
  const dbName = 'notificationsDB';
  const storeName = 'notifications';
  const { data: session } = useSession();
  const checkValidAuth = () => {
    if (typeof window !== 'undefined') {
      const accessToken = localStorage.getItem('access');
      return !!accessToken; // Returns true if access token exists, false otherwise
    }
    return false;
  };
  
  // const getTotalTeamsUnreadCount = useCallback(() => {
  //   return teamCommunityList?.reduce((count, team) => {
  //     return count + team?.notification_count;
  //   }, 0);
  // }, [teamCommunityList]);

  // useEffect(()=>{
  //   const count = getTotalTeamsUnreadCount();
  //   setUnreadCount(count);
  // }, [teamCommunityList, getTotalTeamsUnreadCount])

  useEffect(()=>{
    if (loggedIn) {
      dispatch(getNotificationCounts());
    }
  }, [dispatch, loggedIn])

  useEffect(() => {
    if (globalNotificationData) {
      setUnreadCount(globalNotificationData?.team_unread || 0);
    }
  }, [globalNotificationData]);


  useEffect(() => {
    return onEvent('chat.notification', (event) => {
      setUnreadCount(event?.team_unread || 0);
      dispatch(getNotificationList());
      dispatch(getNotificationCounts());
    });
  }, [dispatch]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  // useEffect(() => {

  //   if (fcmToken && userProfileInfo.fcm_token !== fcmToken) {
  //     // if (fcmToken) {
  //     dispatch(setFcmToken({ fcm_token: fcmToken }));
  //   }
  // }, [fcmToken, notificationPermissionStatus]);

  // packages/mybridgev4/snippets/auth/auth-header/index.jsx

  useEffect(() => {
    if (fcmToken && userProfileInfo?.fcm_token !== fcmToken) {
      // 1. Try to get it from local storage
      let deviceId = localStorage.getItem('DeviceId');

      // 2. If it's not there, generate a new unique one
      if (!deviceId) {
        // Create a random unique string
        deviceId = 'web-' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        // Save it so it's consistent for this browser
        localStorage.setItem('DeviceId', deviceId);
      }

      // 3. Dispatch with both values
      dispatch(setFcmToken({ 
        fcm_token: fcmToken, 
        device_id: deviceId,
        device_type: 'web' 
      }));
    }
  }, [fcmToken, notificationPermissionStatus]);

  const [meetNowModal, setMeetNowModal] = useState(false);
  const {generatedMeetingId} = useSelector((state) => state?.meeting);
  const [domain, setDomain] = useState('');
  const [copyText, setCopyText] = useState(<CopyIcon height={"18px"} width={"18px"}/>);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { createBranchLink } = useBranchLink();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setDomain(window.location.origin+`/meet/${generatedMeetingId}`);
    }
  }, [domain, generatedMeetingId]);

  const handleGenerateLink = async () => {
    try {
      const url = await createBranchLink({
        itemType: 'meeting',
        itemId: generatedMeetingId,
      });
      if (url) {
        copyToClipboard(url);
      }
    } catch (err) {
      console.error(err);
    }
  };
  
  const copyToClipboard = (url) => {
    navigator.clipboard.writeText(url || domain).then(() => {
      setCopyText(t('myCalendar.copied') || 'Copied');
      setTimeout(() => setCopyText(<CopyIcon height={"18px"} width={"18px"}/>), 5000);
    });
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  // eslint-disable-next-line react-hooks/rules-of-hooks
  // eslint-disable-next-line react-hooks/rules-of-hooks

  // Modify handleCardClick to return a URL path based on detail
  const getRedirectUrl = (detail) => {
    if (
      (detail.data.type === 'post_shared' ||
        detail.data.type === 'post_liked' ||
        detail.data.type === 'post_comment' ||
        detail.data.type === 'post_disliked') &&
      detail?.data?.id
    ) {
      return `/post/${detail?.data?.id}`;
    } else if (detail.data.type === 'profile_update') {
      return `/profile/me`;
    } else if (
      detail.data.type === 'testimonial_asked' ||
      detail.data.type === 'testimonial_given'
    ) {
      return `/profile/testimonials`;
    } else if (detail.data.type === 'handshake_request') {
      return `/profile/network`;
    } else if (detail.data.type === 'disk_shared') {
      return `/profile/disk`;
    } else if (detail.data.type === 'event_invite' && detail?.data?.id) {
      return `/myevents/details/${detail?.data?.id}`;
    } else if (
      (detail.data.type === 'team_invite' ||
        detail.data.type === 'team_update' ||
        detail.data.type === 'team_member_joined' ||
        detail.data.type === 'team_member_removed' ||
        detail.data.type === 'team_chat_approval_pending' ||
        detail.data.type === 'team_chat_accept' ||
        detail.data.type === 'team_chat_declined' ||
        detail.data.type === 'team_user_disk_write_access' ||
        detail.data.type === 'team_become_organizer' ||
        detail.data.type === 'team_request' ||
        detail.data.type === 'team_invite_accepted' ||
        detail.data.type === 'disk_subscriber_request' ||
        detail.data.type === 'disk_subscriber_changed') &&
      detail?.data?.slug
    ) {
      return `/teams/${detail?.data?.slug}`;
    } else if (
      (detail.data.type === 'meeting_invite' ||
        detail.data.type === 'meeting_accepted' ||
        detail.data.type === 'attendees_update' ||
        detail.data.type === 'meeting_update') &&
      detail?.data?.id
    ) {
      return `/profile/calendar/viewMeeting/${detail?.data?.id}`;
    } else {
      return `/notification`;
    }
  };

  // Function to strip HTML tags
  const stripHtmlTags = (text) => {
    return text?.replace(/<\/?[^>]+(>|$)/g, ''); // Removes HTML tags
  };

  // useEffect for handling notifications
  useEffect(() => {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      const messaging = getMessaging(getFirebaseApp());
      const unsubscribe = onMessage(messaging, (payload) => {
        // Always refetch notifications and counts when a message is received
        dispatch(getNotificationList());
        dispatch(getNotificationCounts());
        
        try {
          if (payload?.data?.context) {
            const parsedContext = JSON.parse(payload?.data?.context);
            const title = stripHtmlTags(parsedContext.sender_name || 'myBridge');
            const message = parsedContext.msg;

            // Generate the redirect URL based on notification data
            const actionUrl = getRedirectUrl({ data: parsedContext });

            if (Notification.permission === 'granted') {
              const notification = new Notification(title, {
                body: message,
                icon: parsedContext.created_by?.profile_pic,
              });

              notification.onclick = (event) => {
                event.preventDefault();
                window.open(actionUrl, '_blank');
              };
            }
          }
        } catch (error) {
          console.error('Failed to parse notification context:', error);
        }
      });

      // Listen for messages from the service worker (for background notifications)
      const handleServiceWorkerMessage = (event) => {
        if (event.data && event.data.type === 'REFETCH_NOTIFICATIONS') {
          dispatch(getNotificationList());
          dispatch(getNotificationCounts());
        }
      };
      navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);

      return () => {
        unsubscribe();
        navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
      };
    }
  }, [dispatch]);

  useEffect(() => {
    const { data } = onboardingStatus ?? {};
    const { percentage } = data ?? {};
    if (percentage < 100) {
      const { profile, employment, photo, job_availabilty, connect } =
        data ?? {};
      const entries = [
        { name: 'profile', value: profile },
        { name: 'employment', value: employment },
        { name: 'photo', value: photo },
        { name: 'job_availabilty', value: job_availabilty },
        // { name: 'contact', value: contact },
        // { name: 'connect', value: connect },
      ];
      const notBoarded = entries?.find?.((e) => e.value === false)?.name
        ?.length;
      if (notBoarded) {
        // onboardingDisc?.onOpen?.();
        push('/onboarding');
      }
    }
  }, [onboardingStatus]);

  useEffect(() => {
    if (loggedIn) {
      if (userProfileInfo && !is_active) {
        setTimeout(() => {
          dispatch(setOpenAuthModal('activate-account'));
        }, 5000);
      } else {
        if (userProfileInfo?.email?.length) {
          dispatch(getOnboardingStatus({ emailId: userProfileInfo?.email }));
        }
      }
    }
  }, [userProfileInfo, is_active, loggedIn]);

  // useEffect(() => {
  //   if (typeof window !== 'undefined') {
  //     const chatAccess = localStorage.getItem('chatAccess');
  //     const userLanguage = localStorage.getItem('userLanguage') || 'en';
  //     // dispatch(userProfileAddInfo(formData, true))
  //     dispatch(userProfileAddInfo({ lang: userLanguage }, true)).then(() => {
  //       dispatch(getUserProfileInfo())
  //       .then((resp) => {
  //         const status_code = resp?.payload?.status_code ?? {};
  //         // console.log('status_code', status_code > 400);
  //         if (status_code > 400) {
  //           localStorage?.clear();
  //           dispatch(setLoggedIn(false));
  //           console.log('status_code true', status_code > 400);
  //         } else {
  //           dispatch(setLoggedIn(true));
  //           dispatch(getAllConnectionsData());
  //           if (chatAccess?.length) dispatch(setChatLoggedIn(true));
  //           dispatch(loadDictionary(resp?.payload?.lang))
  //           dispatch(setLanguage(resp?.payload?.lang));
  //           console.log('status_code false', status_code > 400);
  //         }
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         if (!localStorage.getItem('userLanguage')) {
  //           localStorage.setItem('userLanguage', 'en');
  //         }
  //       });
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const chatAccess = localStorage.getItem('chatAccess');
      
      // Get userLanguage with a default value of 'en'
      const userLanguage = localStorage.getItem('userLanguage') || 'en';
      
      // Make sure to save the default if it wasn't set
      if (!localStorage.getItem('userLanguage')) {
        localStorage.setItem('userLanguage', userLanguage);
      }
      
      // dispatch(userProfileAddInfo({ lang: userLanguage }, true)).then(() => {
        dispatch(getUserProfileInfo())
        .then((resp) => {
          const status_code = resp?.payload?.status_code;
          const isError = !resp?.payload || resp?.error || resp?.payload?.detail || resp?.payload?.code === 'token_not_valid' || (typeof status_code === 'number' && status_code > 400) || resp?.meta?.requestStatus === 'rejected';
          if (isError) {
            // localStorage?.clear();
            // After clearing localStorage, set default language again
            // localStorage.setItem('userLanguage', 'en');
            dispatch(setLoggedIn(false));
          } else {
            dispatch(setLoggedIn(true));
            // dispatch(getAllConnectionsData());
            // dispatch(getAllCompanyPages());
            if (chatAccess?.length) dispatch(setChatLoggedIn(true));
            
            // Use the language from the response, or fall back to default
            const responseLanguage = resp?.payload?.lang || userLanguage || 'en';
            dispatch(loadDictionary(responseLanguage));
            dispatch(setLanguage(responseLanguage));
            
            // Update localStorage with the confirmed language
            localStorage.setItem('userLanguage', responseLanguage);
          }
        })
        .catch((err) => {
          console.error(err);
          // In case of error, ensure we have a default language
          // if (!localStorage.getItem('userLanguage')) {
          //   localStorage.setItem('userLanguage', 'en');
          // }
        });
      // });
    }
  }, []);

  useEffect(() => {
    if (!loading) {
      dispatch(setPageLoaded(true));
    }
  }, [loading]);  
  // Add handler for teams navigation
  const handleTeamsNavigation = () => {
    if (!isTeamsLoading) {
      if (!(pathname.includes('/teams') || pathname.includes('/t/'))) {
        setIsTeamsLoading(true);
      }
      push('/teams');
      currentMeetingState && dispatch(setMeetingWindowed());
    }
  };

  useEffect(() => {
    if (pathname.includes('/teams') || pathname.includes('/t/')) {
      setIsTeamsLoading(false);
    }
  }, [pathname]);
  // useEffect(() => {
  //   const userLanguage = localStorage.getItem('userLanguage') || 'en';
  //   if (loggedIn) {
  //     dispatch(updateUserDetails({ lang: userLanguage })).then(() => {
  //           localStorage.setItem('userLanguage', userLanguage);
  //           dispatch(setLanguage(userLanguage));
  //           dispatch(loadDictionary(userLanguage));
  //           dispatch(getUserProfileInfo());
  //         });
  //     // dispatch(getUserProfileInfo());
  //   }
  // }, [loggedIn]);

  useEffect(() => {
    if (loggedIn) {
      if (userProfileInfo?.id) return;
      // Get userLanguage with a default value of 'en'
      const userLanguage = localStorage.getItem('userLanguage') || 'en';
      
      // Make sure to save the default if it wasn't set
      if (!localStorage.getItem('userLanguage')) {
        localStorage.setItem('userLanguage', userLanguage);
      }
      
      dispatch(getUserProfileInfo()).then((res) => {
        // Use the language from the response, or fall back to default
        dispatch(setLanguage(res?.payload?.lang));
        localStorage.setItem('userLanguage', res?.payload?.lang);
        dispatch(loadDictionary(res?.payload?.lang));
      });
      // dispatch(updateUserDetails({ lang: userLanguage })).then(() => {
      // });
    }
  }, [loggedIn, userProfileInfo?.id]);

  const tid = useRef(-1);
  useEffect(() => {
    clearTimeout(tid.current);
    tid.current = setTimeout(() => {
      // if (loading) return;
      if (!isReady || loading) return;
      const currentPath = pathname || asPath || '';
      // const hasAccessToken = typeof window !== 'undefined' && !!localStorage.getItem('access');
      const hasAccessToken = typeof window !== 'undefined' && isTokenValid(localStorage.getItem('access'));
      if (
        loggedIn ||
        hasAccessToken ||
        PageRoutes?.find?.((r) => r.isPublic && currentPath.match(r.path)?.[0])
         || currentPath.match(/^\/post\/[^/]+$/)  // /post/[ID]
      ) {
        return;
      }
      return push('/');
    }, 300);
  // }, [loggedIn, loading, pathname]);
  }, [loggedIn, loading, pathname, asPath, isReady]);

  useEffect(() => {
    if (openAuthModal && openAuthModal?.length) {
      openAuthModalDisc.onOpen();
    } else {
      openAuthModalDisc.onClose();
    }
  }, [openAuthModal]);

    const handleSignInOpen = () => {
      push('/signin?source=home');
      //dispatch(setOpenAuthModal('sign-in'));
    };

  const handleSignUpOpen = () => {
    push('/signup?source=home');
    //dispatch(setOpenAuthModal('sign-up'));
  };

  const onClose = () => {
    dispatch(setOpenAuthModal(''));
  };

  const userFullName = getUserFullName(userProfileInfo);
  const userProfilePic = getUserProfilePic(userProfileInfo);
  const { formatNumber } = useNumberFormatter();
  // console.log('teamChatNotications', teamChatNotications);
  useEffect(() => {

    if (session && !loggedIn && session.provider === 'google') {
      const singInObj = {
        id_token: session.id_token,
        email: session.user.email,
        first_name: session?.user?.name?.split(' ')?.[0],
        last_name: session?.user?.name?.split(' ')?.[1],
        access_token: session?.access_token,
        platform: 'google',
      };

//       dispatch(googleSignIn(singInObj)).then((res) => {
//         if (res) {
//           push('/');
//         }
//       });
      dispatch(googleSignIn(singInObj)).then((res) => {
        if (res?.payload?.access) {
          push('/');
        } else {
          signOut({ redirect: false });
        }
      }).catch(() => {
        signOut({ redirect: false });
      });
    }
  }, [session]);
  useEffect(() => {
    const handleUnauthorized = () => {
      dispatch(logout());
      // push('/');
      const currentPath = pathname || asPath || (typeof window !== 'undefined' ? window.location.pathname : '');
      if (!isPublicPath(currentPath)) {
        push('/');
      }
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('auth:unauthorized', handleUnauthorized);
      return () => window.removeEventListener('auth:unauthorized', handleUnauthorized);
    }
  // }, []);
  }, [pathname, asPath]);

  useEffect(() => {
    // Check if access token exists in localStorage
    // const hasAccessToken = typeof window !== 'undefined' && !!localStorage.getItem('access');
    const hasAccessToken = typeof window !== 'undefined' && isTokenValid(localStorage.getItem('access'));
    
    // If user is marked as logged in but no access token exists, log them out
    if (loggedIn && !hasAccessToken) {
      dispatch(setLoggedIn(false));
      dispatch(logout());
    }
  }, [loggedIn]);
  return (
    <>
      {checkValidAuth() && loggedIn ? (
        <>
          {isBrowser && (
            <HStack spacing="10px" justifyContent="space-around">
              {/* <Tooltip label="Home" bg="black" p={2}>
                <IconButton
                  display={['none', 'none', 'flex']}
                  px={8}
                  isActive={pathname === '/' ? true : false}
                  onClick={() => {
                    push('/');
                    currentMeetingState && dispatch(setMeetingWindowed());
                  }}
                  icon={<HomeIcon width="35" height="35" />}
                  variant="homeHeaderButtons"
                />
              </Tooltip>
              <Tooltip label="Network" bg="black" p={2}>
                <IconButton
                  display={['none', 'none', 'flex']}
                  bg="transparent"
                  px={8}
                  isActive={pathname === '/profile/network' ? true : false}
                  onClick={() => {
                    push('/profile/network');
                    currentMeetingState && dispatch(setMeetingWindowed());
                  }}
                  icon={<TeamIcon width="35" height="35" />}
                  variant="homeHeaderButtons"
                />
              </Tooltip>
              <Tooltip label="Jobs" bg="black" p={2}>
                <IconButton
                  display={['none', 'none', 'flex']}
                  bg="transparent"
                  px={8}
                  isActive={pathname === '/jobs' ? true : false}
                  onClick={() => {
                    push('/jobs');
                    currentMeetingState && dispatch(setMeetingWindowed());
                  }}
                  icon={<JobsIcon width="35" height="35" />}
                  variant="homeHeaderButtons"
                />
              </Tooltip>
              <NotificationDropdown /> */}
            </HStack>
          )}

          <HStack pr={[0, '0px']} justifyContent="flex-end">
            <HStack spacing={12} alignItems="center">
              <HStack spacing={[3, 3, '2px']}>
                {isMobileOrTablet ? (
                  <IconButton
                    variant="transparent"
                    px={0}
                    minW="32px"
                    borderRadius="full"
                    w="32px"
                    h="32px"
                    BoxShadow="0px 0px 10px 0px #00000029;0px 4px 5px 0px #0000000F inset;0px -5px 3px 0px #0000000F inset;"
                    bg="#DEDEDE"
                    icon={<SearchIcon width="18" height="18" />}
                    onClick={() => props.onSearchOpen()}
                  />
                ) : (
                  <></>
                )}
                {isMobileOrTablet ? (
                  <IconButton
                    variant="transparent"
                    px={0}
                    minW="32px"
                    borderRadius="full"
                    w="32px"
                    h="32px"
                    BoxShadow="0px 0px 10px 0px #00000029;0px 4px 5px 0px #0000000F inset;0px -5px 3px 0px #0000000F inset;"
                    bg="#DEDEDE"
                    icon={<AddIcon color="#5B5B5B" width="18" height="18" />}
                    onClick={() => dispatch(openCreatePostModal(true))}
                  />
                ) : (
                  <></>
                )}
                {/* {!isMobile && !isTablet ? <StatusDropdown /> : <></>} */}
                {!isMobile ? (
                  <>
                    <NotificationDropdown notifDisc={notifDisc} width="26" height="26" />
                  {/* <Spinner size="lg" /> */}
                    {isTeamsLoading ? (
                      <Box
                        minW="32px"
                        borderRadius="full"
                        w="32px"
                        h="32px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        BoxShadow="0px 0px 10px 0px #00000029;0px 4px 5px 0px #0000000F inset;0px -5px 3px 0px #0000000F inset;"
                        bg="#DEDEDE"
                      >
                        <Spinner size="xs" color="rgb(65, 112, 164)" />
                      </Box>
                    ) : (
                    <IconButton
                        
                      bg="transparent"
                      position="relative"
                      borderRadius="50px"
                      // px={[1, 2, 8]}
                      isActive={pathname === '/notification' ? true : false}
                      size={isMobile ? 'sm' : 'md'} 
                      variant="homeHeaderButtons"
                      onClick={handleTeamsNavigation}
                       {...(pathname.includes('/teams') || pathname.includes('/t/')
                        ? {
                        
                            borderRadius: '50px',
                            BoxShadow:"0px 0px 10px 0px #00000029;0px 4px 5px 0px #0000000F inset;0px -5px 3px 0px #0000000F inset;",
                            bg:"#DEDEDE"
                          }
                        : {})}
                      
                    >
                      
                      <>
                        {/* {teamChatNotications>0 || unreadCount>0 ? ( */}
                        {unreadCount>0 ? (
                          <Badge
                            position="absolute"
                            bg="brandRed.500"
                            color="white"
                            borderRadius="100%"
                            top="0"
                            minW="25px"
                            border="2px solid #ffffff"
                            p="3px 5px"
                            left="50%"
                          >
                            {formatNumber(unreadCount)}
                          </Badge>
                        ) : null}

                        <Tooltip label={t('common.teams') || "Teams"} bg="black" p={2} isDisabled={notifDisc?.isOpen}>
                          <Box as="span">
                            <TeamNewIcon
                              color={(pathname.includes('/teams') || pathname.includes('/t/')) ? "rgb(65, 112, 164)" : "#575757"} 
                              extraColor={(pathname.includes('/teams') || pathname.includes('/t/')) ? "rgb(65, 112, 164)" : "#575757"}
                              width={isMobile ? '18' : '26'}
                              height={isMobile ? '18' : '26'}
                            />
                           
                          </Box>
                        </Tooltip>
                      </>
                    </IconButton>
                    )}
                  </>
                ) : (
                   /* Mobile version with spinner */
                  isTeamsLoading ? (
                    <Box 
                      minW="32px"
                      borderRadius="full"
                      w="32px"
                      h="32px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      BoxShadow="0px 0px 10px 0px #00000029;0px 4px 5px 0px #0000000F inset;0px -5px 3px 0px #0000000F inset;"
                      bg="#DEDEDE"
                    >
                      <Spinner size="xs" color="rgb(65, 112, 164)" />
                    </Box>
                  ) : (
                  <IconButton
                    position="relative"
                    minW="32px"
                    borderRadius="full"
                    w="32px"
                    h="32px"
                    BoxShadow="0px 0px 10px 0px #00000029;0px 4px 5px 0px #0000000F inset;0px -5px 3px 0px #0000000F inset;"
                    bg="#DEDEDE"
                    // onClick={() => {
                    //   push('/teams');
                    //   currentMeetingState && dispatch(setMeetingWindowed());
                    // }}
                    onClick={handleTeamsNavigation}
                  >
                    <>
                      {teamChatNotications > 0 ? (
                        <Badge
                          position="absolute"
                          bg="brandRed.500"
                          color="white"
                          borderRadius="100%"
                          top="0"
                          minW="25px"
                          border="2px solid #ffffff"
                          p="3px 5px"
                          left="50%"
                        >
                          {formatNumber(teamChatNotications)}
                        </Badge>
                      ) : null}

                      <Tooltip label="Teams" bg="black" p={2}>
                        <Box as="span">
                          <TeamNewIcon
                            width={isMobile ? '18' : '26'}
                            height={isMobile ? '18' : '26'}
                            color="#5B5B5B"
                          />
                        </Box>
                      </Tooltip>
                    </>
                  </IconButton>
                  )
                )}

                <ConversationList notifDisc={notifDisc} isAuth={'Auth'} width="26" height="26" />

               {!isMobile&&( <Tooltip label={t('common.newMeeting') || "New Meeting"} bg="black" p={2} isOpen={tooltipOpen} onClose={() => setTooltipOpen(false)} isDisabled={notifDisc?.isOpen}>
                <Button
                  // onClick={() => dispatch(setMeetNow(true))}
                  onClick={() => {
                    setTooltipOpen(false);
                    dispatch(generateMeetingId()).then((res) => {                     
                      if (res) {
                        trackEvent(ANALYTICS_EVENTS.GenerateNewMeeting, userProfileInfo?.slug);
                        setMeetNowModal(true);
                      }
                      // dispatch(setMeetNow(false));
                    });
                  }}
                  variant="none"
                  height="50px"
                  paddingInlineStart={'0px'}
                  paddingInlineEnd={'0px'}
                  onMouseEnter={() => setTooltipOpen(true)} // Show tooltip on hover
                  onMouseLeave={() => setTooltipOpen(false)} // Hide tooltip when mouse leaves
                  leftIcon={
                    <Box
                      style={{
                        // backgroundColor: '#5756465e',
                        borderRadius: '50px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '40px',
                        height: '40px',
                

                      }}
                    
                      _hover={{ backgroundColor: '#E4E6EB' }}

            //            _hover={{
            //   backgroundColor: "brandPrimary.200",
            // }}        
                    >
                      <EventIcon width="24" height="24" />
                    </Box>
                  }
                  justifyContent="flex-start"
                  fontWeight="600"
                  color="#3D5A80"
                />
                </Tooltip>)}

                {/* <MeetingDropdown /> */}
                {isMobile || isTablet ? (
                  // <MyBridgeAvatar
                  //   name={userFullName}
                  //   src={userProfilePic}
                  //   size="sm"
                  //   onClick={() => push('/profile/me')}
                  // />
                  <StatusProfileDropdown />
                ) : (
                  <StatusProfileDropdown />
                )}
              </HStack>
            </HStack>
          </HStack>
        </>
      ) : (
        <>
          {!isMobile && !isTablet ? (
            <HStack
              display={['none', 'none', 'flex']}
              spacing={4}
              flex={1}
              justifyContent="center"
            >
              {/* <Tooltip label="Home" bg="black" p={2}>
                <IconButton
                  display={['none', 'none', 'flex']}
                  px={8}
                  isActive={pathname === '/' ? true : false}
                  onClick={() => {
                    push('/');
                  }}
                  icon={<HomeIcon width="24" height="24" />}
                  variant="homeHeaderButtons"
                />
              </Tooltip> */}
            </HStack>
          ) : (
            <></>
          )}
          {!isMobile && !isTablet && !pending ? (
            <HStack
              display={['none', 'none', 'flex']}
              spacing={4}
              justifyContent="flex-end"
            >
              <Button
                variant="secondary"
                onClick={handleSignInOpen}
                minW="32"
                fontWeight="semibold"
                color="#5E5E5E"
                borderRadius="10px"
              >
                {t('otherModules.logIn') || "Log in"}
              </Button>

              <Button
                onClick={handleSignUpOpen}
                variant="primary"
                minW="32"
                fontWeight="semibold"
                borderRadius="10px"
              >
                {t('signingPage.signUp') || "Sign up"}
              </Button>
            </HStack>
          ) : (
            <></>
          )}
        </>
      )}
      {openAuthModal === 'sign-in' ? (
        <SigninModal {...openAuthModalDisc} onClose={onClose} />
      ) : (
        ''
      )}
      {openAuthModal === 'sign-up' ? (
        <SignupModal {...openAuthModalDisc} onClose={onClose} />
      ) : (
        ''
      )}
      {openAuthModal === 'send-verify-link' ? (
        <SendVerifyLinkModal {...openAuthModalDisc} onClose={onClose} />
      ) : (
        ''
      )}
      {openAuthModal === 'activate-account' ? (
        <ActivateAccountModal {...openAuthModalDisc} onClose={onClose} />
      ) : (
        ''
      )}
      {openAuthModal === 'request-reset-password' ? (
        <RequestResetPasswordModal {...openAuthModalDisc} onClose={onClose} />
      ) : (
        ''
      )}
      {openAuthModal === 'confirm-reset-password' ? (
        <ConfirmResetPasswordModal {...openAuthModalDisc} onClose={onClose} />
      ) : (
        ''
      )}
      {openAuthModal === 'change-email' ? (
        <ChangeEmailModal {...openAuthModalDisc} onClose={onClose} />
      ) : (
        ''
      )}
      {openAuthModal === 'verify-otp' ? (
        <VerifyOtpModal {...openAuthModalDisc} onClose={onClose} />
      ) : (
        ''
      )}
      {openAuthModal === 'forgot-password-reset' ? (
        <ForgotPasswordResetModal {...openAuthModalDisc} onClose={onClose} />
      ) : (
        ''
      )}
      <Modal isOpen={meetNowModal} size={'xl'} isCentered onClose={() => setMeetNowModal(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontWeight={"400"}>{t('myCalendar.yourNewMeetingLink') || 'Your New Meeting Link'}</ModalHeader>
          <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
          <ModalBody pb={6} display={'flex'} flexDirection={'column'} gap={"20px"}>
            <Text>{t('myCalendar.meetingLinkInfo') || 'Here is the link for your new meeting!'}</Text>
            <Text fontSize={"14px"}>{t('myCalendar.copyShareInfo') ||
                  "Copy and share it with the people you're meeting with and be sure to save the link so you can access it again later."}</Text>
            <Box display="flex" alignItems="center" gap="8px">
              <InputGroup>
                <Input borderRadius={"20px"} value={domain} isReadOnly />
                {direction === 'rtl' ? <InputLeftElement width="4.5rem">
                  <Button variant="none" h="1.75rem" size="sm" onClick={handleGenerateLink} title={t('myCalendar.copyToClipboard') || "Copy to clipboard"}>
                    {/* <CopyIcon height={"18px"} width={"18px"}/> */} {copyText}
                  </Button>
                </InputLeftElement> : <InputRightElement width="4.5rem">
                  <Button variant="none" h="1.75rem" size="sm" onClick={handleGenerateLink} title={t('myCalendar.copyToClipboard') || "Copy to clipboard"}>
                    {/* <CopyIcon height={"18px"} width={"18px"}/> */} {copyText}
                  </Button>
                </InputRightElement>}
              </InputGroup>
            </Box>
          </ModalBody>
          <ModalFooter sx={{display: "flex", justifyContent: "start"}}>
            <Button 
              variant="primary" 
              borderRadius="30px" 
              onClick={(e) => {
                dispatch(setMeetNow(true));
                setMeetNowModal(false);
              }}
            >
              {t('myCalendar.joinNow') || 'Join Now'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
